import React, { useState } from 'react';

import moment from 'moment';

import { Formik, Form } from 'formik';

import PropTypes from 'prop-types';

import { FormStyled } from '../../styles/form';

import SelectStyled from '../../styles/select';
import ReactSelect from 'react-select';
import { TextField, withStyles } from '@material-ui/core';
import Button from '@material-ui/core/Button';

const styles = theme => ({
  root: {
    width: '90%',

    marginTop: theme.spacing.unit * 3,

    paddingBottom: theme.spacing.unit * 3,

    overflowX: 'auto',
  },

  textField: {
    margin: theme.spacing.unit * 0.5,

    marginBottom: theme.spacing.unit * 3,

    width: '45%',

    textAlign: 'center',
  },

  textFieldNumber: {
    margin: theme.spacing.unit * 0.5,

    width: '30%',

    textAlign: 'center',
  },
});

const handleValidate = ({ begin, end }) => {
  const errors = {};

  if (!begin) errors.begin = 'OBRIGATÓRIO';

  if (moment(begin).isAfter(end))
    errors.end = 'DATA FINAL NÃO PODE SER MENOR QUE INICIAL';

  if (!end) errors.end = 'OBRIGATÓRIO';

  return errors;
};

const handleSubmit = props => async (values, { setSubmitting }) => {
  await props.onList({ ...values });
  setSubmitting(false);
};

const MaintenanceFilterForm = props => {
  const { equipments, begin, end, classes, handleClosedList } = props;
  const [selectedType, setSelectedType] = useState(null);
  const [selectedSituation, setSelectedSituation] = useState(null);
  const [selectedEquip, setSelectedEquip] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState('open');

  const maintenanceStatusOptions = [
    {
      label: 'ABERTAS',

      value: 'open',
    },

    {
      label: 'FECHADAS',

      value: 'closed',
    },
  ];

  const typeOptions = [
    {
      label: 'PREVENTIVA/CORRETIVA',
      value: 'PREVENTIVA-CORRETIVA',
    },
    {
      label: 'PREVENTIVA',
      value: 'PREVENTIVA',
    },
    {
      label: 'CORRETIVA',
      value: 'CORRETIVA',
    },
    {
      label: 'MATERIAL',
      value: 'MATERIAL',
    },
    {
      label: 'EMBREAGEM',
      value: 'EMBREAGEM',
    },
    {
      label: 'MOTOR PARCIAL',
      value: 'MOTOR PARCIAL',
    },
    {
      label: 'MOTOR COMPLETO',
      value: 'MOTOR COMPLETO',
    },
    {
      label: 'TROCA DE CASQUILHOS',
      value: 'TROCA DE CASQUILHOS',
    },
    {
      label: 'FREIO',
      value: 'FREIO',
    },
    {
      label: 'RADIADOR',
      value: 'RADIADOR',
    },
    {
      label: 'BATERIA',
      value: 'BATERIA',
    },
    {
      label: 'REVISÃO 20K',
      value: 'REVISÃO 20K',
    },
    {
      label: 'REVISÃO 40K',
      value: 'REVISÃO 40K',
    },
    {
      label: 'TROCA DO DIFERENCIAL',
      value: 'TROCA DO DIFERENCIAL',
    },
    {
      label: 'TROCA DA CAIXA',
      value: 'TROCA DA CAIXA',
    },
    {
      label: 'ELÉTRICA',
      value: 'ELÉTRICA',
    },
  ];

  const situationOptions = [
    {
      label: 'PENDENTE',
      value: 'PENDENTE',
    },
    {
      label: 'INICIADA',
      value: 'INICIADA',
    },
    {
      label: 'EM DIAGNOSTICO',
      value: 'EM DIAGNOSTICO',
    },
    {
      label: 'EFETUANDO REPAROS',
      value: 'EFETUANDO REPAROS',
    },
    {
      label: 'AGUARDANDO PEÇA',
      value: 'AGUARDANDO PEÇA',
    },
  ];


  const equiOptions = equipments
    ? equipments.map(equip => ({
        value: equip.uuid,
        label: equip.code && `${equip.code} | ${equip.type} `,
      }))
    : [];

  return (
    <div>
      <h1>FILTROS</h1>
      <Formik
        enableReinitialize
        initialValues={{
          begin: `2025-01-01`,

          end: new Date().toISOString().split('T')[0],

          equipmentPlate: '',

          supplierPlate: '',

          documentPlate: '',

          identifierPlate: '',

          maintenanceNumberPlate: '',

          maintenanceStatus: 'open',
        }}
        validate={handleValidate}
        onSubmit={handleSubmit(props)}
      >
        {({
          values,

          handleChange,

          handleBlur,

          handleReset,

          dirty,

          errors,

          touched,

          setFieldValue,

          isSubmitting,
        }) => (
          <FormStyled>
            <div className="item">
              <div
                style={{
                  display: 'grid',
                  gridTemplateColumns: '1fr 1fr 1fr',
                  gap: '16px',
                  width: '90%',
                  margin: '0 0 0 12px',
                }}
              >
                <TextField
                  id="begin"
                  name="begin"
                  label="Data de Abertura Inicial"
                  type="date"
                  variant="outlined"
                  value={values.begin}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  className={classes.textField}
                  error={!!(errors.begin && touched.begin)}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  style={{ width: '100%' }}
                />

                {errors.begin && touched.begin && <span>{errors.begin}</span>}

                <TextField
                  id="end"
                  name="end"
                  label="Data de Abertura Final"
                  type="date"
                  variant="outlined"
                  value={values.end}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  className={classes.textField}
                  error={!!(errors.end && touched.end)}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  style={{ width: '100%' }}
                />
                <TextField
                  id="equipmentPlate"
                  name="equipmentPlate"
                  label="Placa/Código"
                  type="text"
                  variant="outlined"
                  value={values.equipmentPlate}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  className={classes.textField}
                  error={!!(errors.equipmentPlate && touched.equipmentPlate)}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  style={{ width: '100%' }}
                />
              </div>
              <div
                style={{
                  display: 'grid',
                  gridTemplateColumns: '1fr 1fr',
                  gap: '16px',
                  width: '90%',
                  margin: '0 0 0 12px',
                }}
              >
                <TextField
                  id="supplierPlate"
                  name="supplierPlate"
                  label="Fornecedor"
                  type="text"
                  variant="outlined"
                  value={values.supplierPlate}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  className={classes.textField}
                  error={!!(errors.supplierPlate && touched.supplierPlate)}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  style={{ width: '100%' }}
                />
                <TextField
                  id="documentPlate"
                  name="documentPlate"
                  label="Documento"
                  type="text"
                  variant="outlined"
                  value={values.documentPlate}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  className={classes.textField}
                  error={!!(errors.documentPlate && touched.documentPlate)}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  style={{ width: '100%' }}
                />
              </div>
              <div
                style={{
                  display: 'grid',
                  gridTemplateColumns: '1fr 1fr',
                  gap: '16px',
                  width: '90%',
                  margin: '0 0 0 12px',
                }}
              >
                <TextField
                  id="identifierPlate"
                  name="identifierPlate"
                  label="Identificador"
                  type="text"
                  variant="outlined"
                  value={values.identifierPlate}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  className={classes.textField}
                  error={!!(errors.identifierPlate && touched.identifierPlate)}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  style={{ width: '100%' }}
                />
                <TextField
                  id="maintenanceNumberPlate"
                  name="maintenanceNumberPlate"
                  label="Número da manutenção"
                  type="text"
                  variant="outlined"
                  value={values.maintenanceNumberPlate}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  className={classes.textField}
                  error={
                    !!(
                      errors.maintenanceNumberPlate &&
                      touched.maintenanceNumberPlate
                    )
                  }
                  InputLabelProps={{
                    shrink: true,
                  }}
                  style={{ width: '100%' }}
                />
              </div>
            </div>

            {/* <div> */}
            <ReactSelect
              id="type"
              name="type"
              placeholder="TIPO"
              styles={SelectStyled}
              value={selectedType}
              onChange={e => {
                setSelectedType(e);
                setFieldValue('type', e.value || '');
              }}
              components={{
                IndicatorSeparator: () => null,
              }}
              options={typeOptions}
              noOptionsMessage={() => 'Nenhum tipo encontrado'}
            />

            <ReactSelect
              id="situation"
              name="situation"
              placeholder="SITUAÇÃO"
              styles={SelectStyled}
              value={selectedSituation}
              onChange={e => {
                setSelectedSituation(e);
                setFieldValue('situation', e.value || '');
              }}
              components={{
                IndicatorSeparator: () => null,
              }}
              options={situationOptions}
              noOptionsMessage={() => 'Nenhuma situação encontrada'}
            />

            <div>
              <ReactSelect
                id="equipmentUuid"
                name="equipmentUuid"
                placeholder="EQUIPAMENTO"
                isDisabled={!equiOptions}
                styles={SelectStyled}
                value={selectedEquip}
                onChange={e => {
                  setSelectedEquip(e);
                  setFieldValue('equipmentUuid', e.value || '');
                }}
                components={{
                  IndicatorSeparator: () => null,
                }}
                options={equiOptions}
                noOptionsMessage={() => 'Nenhum equipamento encontrado'}
              />
            </div>
            <ReactSelect
              id="maintenanceStatus"
              name="maintenanceStatus"
              placeholder="STATUS"
              styles={SelectStyled}
              value={maintenanceStatusOptions.find(option => option.value === selectedStatus) || maintenanceStatusOptions[0]}
              onChange={async e => {
                const value = e ? e.value : null;
                setSelectedStatus(value);
                await setFieldValue('maintenanceStatus', value);
              }}
              isClearable={false}
              components={{
                IndicatorSeparator: () => null,
              }}
              options={maintenanceStatusOptions}
              noOptionsMessage={() => 'Nenhum status encontrado'}
            />

            {/* </div> */}
            <Button
              variant="contained"
              color="primary"
              type="submit"
              disabled={props.isSubmitting}
              style={{ marginTop: '20px' }}
            >
              BUSCAR
            </Button>

            <Button
              variant="contained"
              color="primary"
              type="reset"
              onClick={async () => {
                handleReset();
                setSelectedType(null);
                setSelectedEquip(null);
                setSelectedSituation(null);
                setFieldValue('selectedType', null);
                setFieldValue('selectedSituation', null);
                setFieldValue('selectedEquip', null);
                setFieldValue('equipmentPlate', '');
                setFieldValue('supplierPlate', '');
                setFieldValue('documentPlate', '');
                setFieldValue('identifierPlate', '');
                setFieldValue('maintenanceNumberPlate', '');
                setFieldValue(
                  'begin',
                  new Date().toISOString().substring(0, 10)
                );
                setFieldValue('end', new Date().toISOString().substring(0, 10));
                setSelectedStatus('open');
                setFieldValue('maintenanceStatus', 'open');
                if (handleClosedList) handleClosedList('open');
              }}
              disabled={(!dirty && !selectedEquip) || isSubmitting}
              style={{ marginTop: '20px' }}
            >
              DESFAZER
            </Button>
          </FormStyled>
        )}
      </Formik>
    </div>
  );
};

MaintenanceFilterForm.propTypes = {
  accounts: PropTypes.arrayOf(
    PropTypes.shape({
      uuid: PropTypes.string,

      description: PropTypes.string,
    })
  ),

  partners: PropTypes.arrayOf(
    PropTypes.shape({
      uuid: PropTypes.string,

      name: PropTypes.string,
    })
  ),

  costs: PropTypes.arrayOf(
    PropTypes.shape({
      uuid: PropTypes.string,

      description: PropTypes.string,
    })
  ),
};

MaintenanceFilterForm.defaultProps = {
  accounts: [],

  partners: [],

  costs: [],
};

export default withStyles(styles)(MaintenanceFilterForm);

